import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled, { keyframes } from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  white-space: nowrap;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    gap: 1.6rem;
  }
`;

const organicFloat = keyframes`
  0% { background-position: 30% 40%; }
  8% { background-position: 45% 20%; }
  16% { background-position: 65% 15%; }
  24% { background-position: 80% 35%; }
  32% { background-position: 85% 60%; }
  40% { background-position: 75% 80%; }
  48% { background-position: 50% 90%; }
  56% { background-position: 25% 85%; }
  64% { background-position: 15% 65%; }
  72% { background-position: 10% 40%; }
  80% { background-position: 20% 25%; }
  88% { background-position: 35% 15%; }
  96% { background-position: 45% 30%; }
  100% { background-position: 30% 40%; }
`;

export const StyledWrapRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
`;

export const StyledBar = styled.div`
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.4rem 1.2rem;
  gap: 2.4rem;

  overflow: hidden;
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    flex-wrap: wrap;
    flex-basis: 9.7rem;
    flex-shrink: 0;
    justify-content: center;
  }

  background: ${secondaryColors.offBlack};
  background-size: 550% 550%;
    background-image: radial-gradient(
    ellipse at center,
    rgba(11, 86, 63, 1.0) 0%,
    rgba(11, 86, 63, 0.7) 25%,
    rgba(11, 86, 63, 0.4) 40%,
    rgba(11, 86, 63, 0.1) 60%,
    transparent 80%
  );
  animation: ${organicFloat} 10s ease-in-out infinite;
  animation-delay: -5s;

  & > * {
    z-index: 10;
  }
`;

const animation = keyframes`
  0%, 45% {
    transform: translateY(0);
    opacity: 1;
  }
  50%, 75% {
    transform: translateY(-100%);
    opacity: 1;
  }
  75.001% {
    transform: translateY(-100%);
    opacity: 0;
  }
  75.002% {
    transform: translateY(100%);
    opacity: 0;
  }
  95% {
    transform: translateY(100%);
    opacity: 1;
  }
`;

export const StyledText = styled.p`
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: 2.8rem;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;

// Stagger animations: show shorter content first, then longer content
export const StyledAnimatableBox = styled.p<{
  $animate?: boolean;
  $delay?: boolean;
}>`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.main};
  position: ${({ $delay = false }) => ($delay ? 'absolute' : 'relative')};

  animation: ${({ $animate = false }) => ($animate ? animation : 'none')} 8s infinite ease-in-out;
  animation-delay: ${({ $delay = false }) => ($delay ? '-4s' : '0s')};
`;

export const StyledHighlight = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const StyledTitle = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;
